export function contactForms() {
    document.addEventListener('wpcf7mailsent', function (event) {
        swal({
            title: "Thank you!",
            text: "Your message has been sent.",
            icon: "success",
            timer: 3000,
            buttons: false,
        });
        $.fancybox.close();
    }, false);
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/forms.js